var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpiralFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1723,
    height: 246,
    viewBox: "0 0 1723 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-140 107.911C38.822 107.911 89.6237 238 172.126 238C316.809 238 322.499 8 452.551 8C582.603 8 612.967 238 773.5 238C934.033 238 967.071 8 1093.06 8C1219.05 8 1258.47 238 1442.98 238C1555.96 238 1637.49 8 1723 8",
    stroke: "#F6F6F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M-140 138.089C38.822 138.089 89.6237 8 172.126 8C316.809 8 322.499 238 452.551 238C582.603 238 612.967 8 773.5 8C934.033 8 967.071 238 1093.06 238C1219.05 238 1258.47 8 1442.98 8C1555.96 8 1637.49 238 1723 238",
    stroke: "#F6F6F6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 173,
    cy: 238,
    r: 8,
    fill: "#F6F6F6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 784,
    cy: 238,
    r: 8,
    fill: "#F6F6F6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1090,
    cy: 8,
    r: 8,
    fill: "#F6F6F6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 454,
    cy: 8,
    r: 8,
    fill: "#F6F6F6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1435,
    cy: 238,
    r: 8,
    fill: "#F6F6F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpiralFull);
export default __webpack_public_path__ + "static/media/spiral-full.d567b440ba1e8888e1392c0c22a3de86.svg";
export { ForwardRef as ReactComponent };